<div class="coach-chat-spinner">
	@if (loadingCoachChat()) {
		<nz-spin nzSimple nzSize="large"></nz-spin>
	}
</div>
@if (!loadingCoachChat() && chat() && chat()!.interactions.length > 0) {
	<div class="coach-chat">
		@for (interaction of chat()!.interactions; track interaction; let interactionIndex = $index) {
			@for (message of interaction.messages; track message; let messageIndex = $index; let isFirst = $first) {
				<div
					class="message-container"
					[attr.data-role]="message.role"
					[ngStyle]="'assistant' === message.role ? getNpcColorStyle(message.npcUuid) : {}"
				>
					<div
						[ngClass]="[
							message.role,
							'text',
							'message-bubble',
							message.correct === true ? 'correct' : '',
							message.correct === false ? 'incorrect' : '',
						]"
					>
						{{ message.text }}
						@if (message.mp3Urls?.length) {
							<br />
							<br />
							@for (url of message.mp3Urls; track url) {
								<app-audio-button [audioUrl]="url"></app-audio-button>
							}
						}
					</div>
					@if (message.feedback) {
						<div [ngClass]="[message.role, 'feedback', 'message-bubble']">
							{{ message.feedback }}
						</div>
					}
				</div>
			}
		}
	</div>
}

@if (chat() && chat()!.interactions.length === 0) {
	<div class="no-messages-found">No messages found in chat.</div>
}
